import { render, staticRenderFns } from "./schoolScreen.vue?vue&type=template&id=6a00d30c"
import script from "./schoolScreen.vue?vue&type=script&lang=js"
export * from "./schoolScreen.vue?vue&type=script&lang=js"
import style0 from "./schoolScreen.vue?vue&type=style&index=0&id=6a00d30c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports